<template>
    <div id="settings-page">
        <loader v-if="is('loading')"></loader>

        <div class="container-fluid" v-if="is('ready')">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="box clearfix">
                        <h1>{{ t('quotationStatus-title') }}</h1>
                        <table class="table table-striped">
                            <tr
                                v-for="status in externalStatus"
                                :key="status.id"
                            >
                                <td>{{ status.external_label }}</td>
                                <td>
                                    <select
                                        v-model="status.kevi_status"
                                        class="form-control"
                                    >
                                        <option value="draft">
                                            {{ t('quotationStatus-status_options-draft') }}
                                        </option>
                                        <option value="sent">
                                            {{ t('quotationStatus-status_options-sent') }}
                                        </option>
                                        <option value="accepted">
                                            {{ t('quotationStatus-status_options-accepted') }}
                                        </option>
                                        <option value="rejected">
                                            {{ t('quotationStatus-status_options-rejected') }}
                                        </option>
                                        <option value="expired">
                                            {{ t('quotationStatus-status_options-expired') }}
                                        </option>
                                        <option value="cancelled">
                                            {{ t('quotationStatus-status_options-cancelled') }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                        <button
                            class="btn btn-success pull-right"
                            @click.prevent="save"
                            :disabled="is('saving')"
                        >
                            <span
                                class="fa fa-spin fa-spinner"
                                v-if="is('saving')"
                            ></span>
                            {{ t('quotationStatus-save_button') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";

export default {
    props: {
        user: Object,
    },
    data: function () {
        return {
            state: "ready",
            externalStatus: [],
        };
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            this.t('quotationStatus-page_title');
        this.loadData();
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        loadData: function () {
            let options = keviApi.getOptions(
                "settings/external-quotations-status",
                "GET",
            );
            this.setState("loading");
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.externalStatus = response.body.status || [];
                }
                this.setState("ready");
            });
        },
        save: function () {
            var options = keviApi.getOptions(
                "settings/external-quotations-status",
                "POST",
                { ...this.externalStatus },
            );
            window?.mixpanel?.track("Settings - save status");
            this.setState("saving");
            this.$http(options).then((response) => {
                this.$store.dispatch(
                    "notification/success",
                    this.t('quotationStatus-status_updated'),
                );
                if (response.status === 200) {
                    this.externalStatus = response.body.status || [];
                }
                this.setState("ready");
            });
        },
    },
};
</script>
